import { gql } from '@apollo/client'

import { ZoneFragment } from '../fragments'

export const ZONING = gql`
  query zones($input: ZoningFindInput!) {
    zoning(input: $input) {
      ...ZoneFragment
    }
  }
  ${ZoneFragment}
`

export const ZONE = gql`
  query zone($id: ID!) {
    zone(id: $id) {
      ...ZoneFragment
      parent {
        ...ZoneFragment
        parent {
          ...ZoneFragment
        }
      }
    }
  }
  ${ZoneFragment}
`
